
import {map, catchError} from 'rxjs/operators';
import { Injectable }     from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import 'rxjs/Rx';
import {Page} from './Page';
import {ClrDatagridStateInterface} from '@clr/angular';
import {environment} from 'src/environments/environment';
import {HIUser} from './HIUser';
import {RestStateInterface} from './RestStateInterface';


@Injectable()
export class DataService {
    constructor(private http: HttpClient) {
    }

    baseUrl = environment.baseUrl;
    base = {'Accept': 'application/json', 'Content-Type': 'application/json'};

    public callGetPaged<T>(url: string, state: RestStateInterface = null): Observable<Page<T>> {
        const toApply: Map<string, any> = new Map<string, string>();
        const options = {headers: this.base, withCredentials: true};
        if (state) {
            if (state.page) {
                const pageNo = Math.floor(state.page.from / state.page.size);
                toApply.set('size', state.page.size);
                toApply.set('page', pageNo);
            }
            if (state.filters) {
                for (const filter of state.filters) {
                    const {property, value} = <{ property: string, value: string }>filter;
                    toApply.set(property, value);
                }
            }
            if (state.sort) {
                if (state.sort.reverse) {
                    toApply.set('sort', state.sort.by + ',desc');
                } else {
                    toApply.set('sort', state.sort.by);
                }
            }
        }
        url += '?';
        toApply.forEach((v: string, k: string) => {
            url += k + '=' + v + '&';
        });
        return this.http.get<Page<T>>(this.baseUrl + url, options);
    }

    public callGet(url: string, newAuth?: string): any {
        const options = {headers: this.base, withCredentials: true};
        if (newAuth) {
            this.base['authorization'] = 'Basic ' + btoa(newAuth);
            // options.withCredentials= false;
        }

        return this.http.get(this.baseUrl + url, options).pipe(
            map((response: Response) => {
                return response;
            }),
            catchError(this.handleError),);
    }

    public callPostAndGet(url: string, body: string): any {
        return this.http.post(this.baseUrl + url, body, {
            headers: this.base,
            withCredentials: true,
            observe: 'response'
        })
            .flatMap((res: any) => {
                const location = res.headers.get('Location');
                return this.http.get(location, {headers: this.base, withCredentials: true});
            }).map((res: Response) => res)
            .catch(this.handleError);
    }

    public callPost(url: string, body: string): any {
        return this.http.post(this.baseUrl + url, body, {headers: this.base, withCredentials: true, observe: 'response'})
            .pipe(
                map(
                    response => {
                        return response
                    },
                    error => {
                        console.log('Error:  ' + error);
                    }))
            .catch(this.handleError);
    }

    public callPut(url: string, body: string): any {
        return this.http.put(this.baseUrl + url, body, {headers: this.base, withCredentials: true}).pipe(
            map(
                response => {
                    return response;
                },
                error => {
                    console.log('Error: ' + error);
                }));
    }

    public callGetAuthenticate(url: string, body: string): any {
        this.base['authorization'] = 'Basic ' + btoa(body + ':noPassword');
        const options = {headers: this.base, withCredentials: true};

        return this.http.get(this.baseUrl + url, options).pipe(
            map((response: Response) => {
                return response;
            }),
            catchError(this.handleError),);
    }

    public callPostNoAuth(url: string, body: string): any {
        this.base['authorization'] = 'Basic ' + btoa(body + ':noPassword');
        return this.http.post(this.baseUrl + url, body, {headers: this.base}).pipe(
            map(
                response => {
                    return response
                },
                error => {
                    console.log('Error:  ' + error);
                }));
    }


    public callDelete(url: string): any {
        return this.http.delete(this.baseUrl + url, {headers: this.base, withCredentials: true}).pipe(map(response => response, error => {
            console.log('Error: ' + error);
        }));
    }


    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Something bad happened; please try again later.');
    }
}
